import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "pre-order"
};
const _hoisted_2 = { class: "pre-order__wrap" };
const _hoisted_3 = { class: "pre-order__na" };
const _hoisted_4 = { class: "message message--md message--strong message--icon" };
const _hoisted_5 = { class: "message__icon" };
const _hoisted_6 = { class: "pre-order__text" };
const _hoisted_7 = { class: "pre-order__button" };
const _hoisted_8 = ["data-id", "data-type"];
import Sprite from "../../../components/Sprite.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PreOrder',
    props: {
        available: { type: Boolean },
        type: { type: Object },
        productId: { type: Number, required: true },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            var _a, _b, _c, _d;
            return (!__props.available || __props.type.disabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("span", _hoisted_5, [
                                    _createVNode(Sprite, {
                                        name: "cart-cross",
                                        size: 32
                                    })
                                ]),
                                _cache[0] || (_cache[0] = _createTextVNode()),
                                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "message__text" }, "Товара нет в наличии", -1 /* HOISTED */))
                            ])
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_6, "Вы можете оформить предзаказ и мы свяжемся с вами,\n        когда " + _toDisplayString((_c = (_b = (_a = __props.type) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase('ru')) !== null && _c !== void 0 ? _c : 'товар') + " появится в наличии\n      ", 1 /* TEXT */),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn--1 btn--l btn--black win",
                                "data-act": "preorder",
                                "data-id": __props.productId,
                                "data-type": (_d = __props.type) === null || _d === void 0 ? void 0 : _d.id
                            }, _cache[2] || (_cache[2] = [
                                _createElementVNode("span", { class: "btn__label" }, "Предзаказ", -1 /* HOISTED */)
                            ]), 8 /* PROPS */, _hoisted_8)
                        ])
                    ])
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
